var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0872 1.7715L3.49908 6.35948C3.36144 6.49713 3.18075 6.56641 3.00006 6.56641C2.81938 6.56641 2.63869 6.49713 2.50104 6.35948L0.207053 4.06549C-0.0690175 3.78955 -0.0690175 3.34339 0.207053 3.06745C0.482993 2.79138 0.929022 2.79138 1.20509 3.06745L3.00006 4.86242L7.08916 0.773459C7.3651 0.497389 7.81113 0.497389 8.0872 0.773459C8.36314 1.0494 8.36314 1.49543 8.0872 1.7715Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick.4534f2fd.svg";
export { ForwardRef as ReactComponent };